import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5.306 3.7a.7.7 0 0 1 .7-.7h11.988a.7.7 0 1 1 0 1.4H6.006a.7.7 0 0 1-.7-.7Zm0 4.611a.7.7 0 0 1 .7-.7h11.988a.7.7 0 1 1 0 1.4H6.006a.7.7 0 0 1-.7-.7Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5.306 3.7a.7.7 0 0 1 .7-.7h4.584a5.338 5.338 0 0 1 0 10.677H8.013l7.65 6.075a.7.7 0 1 1-.87 1.096L5.57 13.525a.7.7 0 0 1 .436-1.248h4.584a3.938 3.938 0 0 0 0-7.877H6.006a.7.7 0 0 1-.7-.7Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
